module.exports = __webpack_public_path__ + "static/media/adserver_section2.7db98a3a.png";